<template>
  <b-button v-bind="$attrs" v-on="$listeners">
    <!-- Forward all scoped slots (includes default) -->
    <template v-for="(_, name) in $scopedSlots" v-slot:[name]="slotProps">
      <slot :name="name" v-bind="slotProps || {}" />
    </template>
  </b-button>
</template>

<script lang="ts">
import { Component, Vue } from 'vue-property-decorator'

@Component({
  name: 'BaseBtn',
  inheritAttrs: false
})
export default class extends Vue {}
</script>
